import { WebTestProps } from '../../layouts'
import { Hero } from './Hero'

export function HeroSection({ web }: WebTestProps) {
  return <Hero web={web} />
}

export default HeroSection
